import { showError } from '@components/app-error';
import { showToast } from '@components/toaster';
import { IntlFn } from 'shared/intl/types';

/**
 * What to show when marking a lesson complete is refused. A required
 * discussion comes back as `commentFirst`, and the student is taken to the
 * comment box; anything else is a plain error.
 */
export function showCompleteLessonError(intl: IntlFn, err: unknown) {
  const refusal = err as { data?: { commentFirst?: boolean }; message?: string };
  if (refusal.data?.commentFirst) {
    showToast({
      type: 'warn',
      title: intl('Comment is required'),
      message: refusal.message || '',
    });
    document.querySelector('.js-root-comment-form')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  } else {
    showError(err as Error);
  }
}
